import { render, staticRenderFns } from "./co-brokering-tab.vue?vue&type=template&id=3ed58c1e"
import script from "./co-brokering-tab.vue?vue&type=script&lang=js"
export * from "./co-brokering-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports